import { B, stu } from "../domain/context.js";
import { avatar } from "../lib/avatar.js";
import { card, classChip, emptyNote } from "../components/ui.js";
import { esc } from "../lib/fmt.js";

// ---------- GÜNLÜK RAPOR ----------
export function viewRapor() {
  const t = B();
  if (!t.dailyReports.length) return card(emptyNote("Bugün için girilmiş rapor yok."), "p-4");
  return `
  <p class="text-sm text-inksoft mb-4">Öğretmenlerin gün içinde girdiği raporlar — gün sonunda velilere otomatik iletilir.</p>
  <div class="grid gap-4 md:grid-cols-2">
    ${t.dailyReports.map(r => {
      const s = stu(r.studentId);
      return card(`
        <div class="p-5">
          <div class="flex items-center gap-3 mb-3">
            ${avatar(s, "w-10 h-10 text-sm")}
            <div class="min-w-0 flex-1">
              <div class="font-semibold">${esc(s.name)}</div>
              ${classChip(s.classId)}
            </div>
            <span class="text-xs font-semibold rounded-full bg-grape-soft text-grape px-2.5 py-1">${esc(r.mood)}</span>
          </div>
          <dl class="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
            <div><dt class="text-[11px] text-inksoft font-semibold">🥐 Kahvaltı</dt><dd>${esc(r.meals.kahvalti)}</dd></div>
            <div><dt class="text-[11px] text-inksoft font-semibold">🍲 Öğle</dt><dd>${esc(r.meals.ogle)}</dd></div>
            <div><dt class="text-[11px] text-inksoft font-semibold">😴 Uyku</dt><dd>${esc(r.sleep)}</dd></div>
            <div><dt class="text-[11px] text-inksoft font-semibold">🚽 Tuvalet</dt><dd>${esc(r.toilet)}</dd></div>
          </dl>
          ${r.note ? `<p class="mt-3 text-sm bg-paper rounded-xl px-3 py-2">📌 ${esc(r.note)}</p>` : ""}
        </div>`);
    }).join("")}
  </div>`;
}

